<template>
    <div>
        <b-form v-show="!collapsed" @submit.prevent class="pt-3">
            <lg-form-input v-model="descricao" label=" " description=" " placeholder="Pesquisar menu" />
        </b-form>
        <div v-for="(filter, i) in filteredMenus" :key="i">
            <b-button v-if="filter.menu && filter.menu.length > 0" class="m-1" variant="primary"
                @click="handleMenuClick(filter.value.substring(0, 5), $event)">
                <b-icon v-if="filter.icon && collapsed" :icon="filter.icon" class="sidebar-menu-icon" />
                <span v-if="!collapsed">{{ filter.value }}</span>
            </b-button>
            <b-collapse :id="filter.value.substring(0, 5)" v-model="openMenus[filter.value.substring(0, 5)]">
                <ul class="nav" style="list-style: none">
                    <li v-for="(link, index) in filter.menu" :key="index" :name="link.name" class="nav-item"
                        style="color: white; font-weight: 400">
                        <router-link class="nav-link" :to="link.to || '/almoxarifado'" style="position: relative">
                            <b-icon v-if="link.icon" :icon="link.icon" class="sidebar-menu-icon" />
                            <span v-if="!collapsed">{{ link.name }}</span>
                        </router-link>
                    </li>
                </ul>
            </b-collapse>
        </div>
    </div>
</template>

<script>
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"
import verificaModulos from "@/utils/VerificaModulos"

export default {
    props: {
        filteredOptions: {
            type: Array,
            required: true
        },
        collapsed: {
            type: Boolean,
            default: false
        }
    },
    components: {
        LgFormInput,
    },
    data() {
        return {
            descricao: "",
            openMenus: {}
        }
    },
    computed: {
        filteredMenus() {
            if (!this.descricao) return this.filteredOptions

            const termo = this.descricao.toLowerCase()
            const filtrados = this.filteredOptions
                .map(opt => {
                    const submenusFiltrados = (opt.menu || []).filter(sub =>

                        !(sub.permissao && sub.permissao != "" && verificaModulos(opt.modulo.cod, opt.sistema) && sub.permissao != PrivilegiosEnum.NAO_NECESSITA_PERMISSAO && !verificaPrivilegio(sub.permissao, opt.sistema)) && sub.name && sub.name.toLowerCase().includes(termo)
                    )
                    if (submenusFiltrados.length > 0) {
                        return { ...opt, menu: submenusFiltrados }
                    }
                    return null
                })
                .filter(Boolean)

            this.$nextTick(() => {
                filtrados.forEach(opt => {
                    const id = opt.value.substring(0, 5)
                    if (!this.openMenus[id]) this.$set(this.openMenus, id, true)
                })
            })

            return filtrados
        }
    },
    watch: {
        collapsed(newVal) {
            if (newVal) {
                this.openMenus = {};
            }
        },
        descricao(newVal) {
            if (!newVal) {
                this.openMenus = {};
            }
        }
    },
    methods: {
        handleMenuClick(id, event) {
            if (this.collapsed) {
                event.preventDefault();
                this.$emit('toggle-collapse');
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.$set(this.openMenus, id, true);
                    }, 100);
                });
            } else {
                this.$set(this.openMenus, id, !this.openMenus[id]);
            }
        }
    }
};
</script>
